import Draggable24 from '@carbon/icons-react/es/draggable/24';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ResourceSectionType } from 'data/documents';
import { useTranslation } from 'hooks/use-translation';
import { HighlightSection } from './highlight-section';
import styles from './status-update-highlights.module.css';

export const StatusUpdateTemplateHighlights = (): JSX.Element => {
  const tasksLabel = useTranslation('tasks');
  const approvalsLabel = useTranslation('approvals');
  const milestonesLabel = useTranslation('milestones');

  return (
    <div className={styles.container}>
      <div className={styles.help}>
        <Draggable24 />
        <FormattedMessage id="status_updates.help" />
      </div>

      <HighlightSection
        config={{
          title: tasksLabel,
          type: ResourceSectionType.Task,
        }}
      />
      <HighlightSection
        config={{
          title: milestonesLabel,
          type: ResourceSectionType.Milestone,
        }}
      />
      <HighlightSection
        config={{
          title: approvalsLabel,
          type: ResourceSectionType.Approval,
        }}
      />
    </div>
  );
};
